export const frequencies = [
  {
    value: 1,
    label: '1 сообщение каждую 1 сек',
  },
  {
    value: 3,
    label: '1 сообщение каждые 3 сек',
  },
  {
    value: 5,
    label: '1 сообщение каждые 5 сек',
  },
  {
    value: 10,
    label: '1 сообщение каждые 10 сек',
  },
  {
    value: 15,
    label: '1 сообщение каждые 15 сек',
  },
  {
    value: 30,
    label: '1 сообщение каждые 30 сек',
  },
  {
    value: 60,
    label: '1 сообщение каждую 1 мин',
  },
  {
    value: 120,
    label: '1 сообщение каждые 2 мин',
  },
  {
    value: 180,
    label: '1 сообщение каждые 3 мин',
  },
  {
    value: 240,
    label: '1 сообщение каждые 4 мин',
  },
  {
    value: 300,
    label: '1 сообщение каждые 5 мин',
  },
  {
    value: 600,
    label: '1 сообщение каждые 10 мин',
  },
  {
    value: 900,
    label: '1 сообщение каждые 15 мин',
  },
  {
    value: 1800,
    label: '1 сообщение каждые 30 мин',
  },
  {
    value: 2700,
    label: '1 сообщение каждые 45 мин',
  },
  {
    value: 3600,
    label: '1 сообщение каждый 1 час',
  },
];
